type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;

export async function ensurePlatformAiStreamSessionsSchema(params: { rawSql: RawSql }): Promise<void> {
  await params.rawSql(`
        CREATE TABLE IF NOT EXISTS platform_ai_stream_sessions (
            id SERIAL PRIMARY KEY,
            request_id TEXT NOT NULL UNIQUE,
            user_id TEXT NOT NULL,
            app_id INTEGER,
            app_name TEXT,
            model TEXT NOT NULL,
            auth_type TEXT NOT NULL,
            state TEXT NOT NULL,
            reserved_credits REAL NOT NULL,
            estimated_input_tokens INTEGER NOT NULL,
            estimated_output_tokens INTEGER NOT NULL,
            actual_input_tokens INTEGER,
            actual_output_tokens INTEGER,
            actual_total_tokens INTEGER,
            credits_captured REAL,
            provider_request_id TEXT,
            reservation_ledger_entry_id INTEGER,
            settlement_owner TEXT,
            settlement_attempted_at TIMESTAMPTZ,
            settled_at TIMESTAMPTZ,
            last_error_code TEXT,
            last_error_detail TEXT,
            started_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
            ended_at TIMESTAMPTZ,
            updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
        )
    `);
}
